module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 003.536bed2a.jpg";